module.exports = __webpack_public_path__ + "img/ads.d2dab34.webp";